import React from "react";
import {Modal} from "antd";

const CustomerCreditWarningModal = ({content, visible, onCancel}) => {
    return (
        <Modal
            title="Kredi Yetersiz"
            visible={visible}
            onCancel={onCancel}
            footer={null}
            width={400}
            className="customer-credit-warning-modal"
        >
            <div style={{padding: "20px 0", textAlign: "center"}}>
                <p style={{fontSize: "16px", color: "#666", marginBottom: "20px"}}>
                    {content || "Siparişinizi tamamlamak için yeterli bakiyeniz bulunmamaktadır."}
                </p>
                <button
                    onClick={onCancel}
                    style={{
                        backgroundColor: "#cf1322",
                        border: "none",
                        borderRadius: "8px",
                        padding: "12px 24px",
                        color: "#000000",
                        fontWeight: "600",
                        cursor: "pointer"
                    }}
                >
                    Tamam
                </button>
            </div>
        </Modal>
    );
};

export default CustomerCreditWarningModal;
